import { Component, input, InputSignal, model, ModelSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { from as observableFrom, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { WsTypeaheadDirective } from '../typeahead.directive';
import { AceLoaderComponent } from '../../ACE/Loader/loader.component';

@Component({
    selector: 'multi-typeahead',
    templateUrl: './multiTypeahead.component.html',
    styleUrls: ['./multiTypeahead.component.scss'],
    imports: [FormsModule, WsTypeaheadDirective, AceLoaderComponent],
})
export class MultiTypeaheadComponent {
    availableItems: InputSignal<any[]> = input();
    selectedItems: ModelSignal<any[]> = model([]);
    isReadonly: InputSignal<boolean> = input(false);
    placeholder: InputSignal<string> = input('Search users...');
    valueIdProp: InputSignal<string> = input('contactId');
    displayNameProp: InputSignal<string> = input('name');

    typeaheadFilter: string = '';
    typeaheadValues$: Observable<any[]> = (
        Observable.create((observer: any) => {
            observer.next(this.typeaheadFilter);
        }) as Observable<string>
    ).pipe(mergeMap((token) => this._filterValues(token)));

    onValueSelected(match: TypeaheadMatch): void {
        const selected = match.item;

        // Don't add duplicates
        if (this.selectedItems().some((c) => c[this.valueIdProp()] === selected[this.valueIdProp()])) {
            this.typeaheadFilter = '';
            return;
        }

        this.selectedItems.set([...this.selectedItems(), selected]);
        this.typeaheadFilter = '';
    }

    removeContact(index: number): void {
        if (this.isReadonly()) {
            return;
        }
        this.selectedItems.set(this.selectedItems().filter((_, i) => i !== index));
    }

    private _filterValues(filter: string): Observable<any[]> {
        const selectedItems = this.selectedItems() || [];
        const selectedIds = new Set(selectedItems.map((c) => c[this.valueIdProp()]));
        const filtered = this.availableItems().filter(
            (x) =>
                x[this.displayNameProp()].toLowerCase().includes(filter.toLowerCase()) &&
                !selectedIds.has(x[this.valueIdProp()]),
        );

        return observableFrom([filtered]);
    }
}
